module.exports = __webpack_public_path__ + "static/media/bell.8d6b93a7.svg";